// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fallow-ignore-next-line unused-export */
.e29eAmjq6s_TUfGlSTiS {
  position: absolute;
  z-index: 3;
  width: max-content;
  bottom: 80%;
  right: -30%;
}
.e29eAmjq6s_TUfGlSTiS picture {
  display: flex;
}
/* fallow-ignore-next-line unused-export */
.KHaLyzuFhvHrMa0yoZYQ {
  object-fit: cover;
  display: block;
  width: var(--campaign-badge-size-desktop);
  height: var(--campaign-badge-size-desktop);
  transform: rotate(30deg);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .e29eAmjq6s_TUfGlSTiS {
    bottom: var(--campaign-badge-bottom-mobile-portrait);
  }
  .KHaLyzuFhvHrMa0yoZYQ {
    width: var(--campaign-badge-size-mobile-portrait);
    height: var(--campaign-badge-size-mobile-portrait);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .e29eAmjq6s_TUfGlSTiS {
    bottom: var(--campaign-badge-bottom-mobile-portrait);
  }
  .KHaLyzuFhvHrMa0yoZYQ {
    width: var(--campaign-badge-size-mobile-portrait);
    height: var(--campaign-badge-size-mobile-portrait);
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (min-width: 768px) and (max-color:2147477350) and (orientation: portrait) {
  .KHaLyzuFhvHrMa0yoZYQ {
    width: var(--campaign-badge-size-mobile-portrait);
    height: var(--campaign-badge-size-mobile-portrait);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (min-width: 768px) and (color:2147477350) and (orientation: portrait) {
  .KHaLyzuFhvHrMa0yoZYQ {
    width: var(--campaign-badge-size-mobile-portrait);
    height: var(--campaign-badge-size-mobile-portrait);
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .KHaLyzuFhvHrMa0yoZYQ {
    width: var(--campaign-badge-size-mobile-landscape);
    height: var(--campaign-badge-size-mobile-landscape);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .KHaLyzuFhvHrMa0yoZYQ {
    width: var(--campaign-badge-size-mobile-landscape);
    height: var(--campaign-badge-size-mobile-landscape);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PrizeFundCampaign/CampaignBadge/css/base/CampaignBadge.base.module.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;EACzC,0CAA0C;EAC1C,wBAAwB;AAC1B;AACA;AAAA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,iDAAiD;IACjD,kDAAkD;EACpD;AACF;AAAA;AARA;AAAA;AAAA;AAAA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,iDAAiD;IACjD,kDAAkD;EACpD;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,iDAAiD;IACjD,kDAAkD;EACpD;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;IACE,iDAAiD;IACjD,kDAAkD;EACpD;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,kDAAkD;IAClD,mDAAmD;EACrD;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;IACE,kDAAkD;IAClD,mDAAmD;EACrD;AACF;AAAA;AAAA;AAAA","sourcesContent":["/* fallow-ignore-next-line unused-export */\n.wrapper {\n  position: absolute;\n  z-index: 3;\n  width: max-content;\n  bottom: 80%;\n  right: -30%;\n}\n.wrapper :global(picture) {\n  display: flex;\n}\n/* fallow-ignore-next-line unused-export */\n.image {\n  object-fit: cover;\n  display: block;\n  width: var(--campaign-badge-size-desktop);\n  height: var(--campaign-badge-size-desktop);\n  transform: rotate(30deg);\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .wrapper {\n    bottom: var(--campaign-badge-bottom-mobile-portrait);\n  }\n  .image {\n    width: var(--campaign-badge-size-mobile-portrait);\n    height: var(--campaign-badge-size-mobile-portrait);\n  }\n}\n@media (min-width: 768px) and (--campaign-mobile) and (orientation: portrait) {\n  .image {\n    width: var(--campaign-badge-size-mobile-portrait);\n    height: var(--campaign-badge-size-mobile-portrait);\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .image {\n    width: var(--campaign-badge-size-mobile-landscape);\n    height: var(--campaign-badge-size-mobile-landscape);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `e29eAmjq6s_TUfGlSTiS`,
	"image": `KHaLyzuFhvHrMa0yoZYQ`
};
export default ___CSS_LOADER_EXPORT___;
